import { cloneDeep } from 'lodash';
import { useMemo } from 'react';
import { useQuery, UseQueryResult } from 'react-query';
import { Filters, FilterType, Snippet, SnippetType } from '../../models';
import { fetchSnippets } from '../../services/snippets/snippets.service';
import { getGroupedFilterTags } from '../../utils/filterUtils';
import { queryKeys } from '../queryKeyFactory';

export default (type: SnippetType, filters: Filters | null): UseQueryResult<Snippet[], Error> => {
  const tags = useMemo(() => {
    if (!filters?.tags) {
      return [];
    }
    const copy = cloneDeep(filters);
    delete copy.tags?.[FilterType.source];

    return getGroupedFilterTags(copy);
  }, [filters]);

  const snippetParams = { type, tags };
  return useQuery<Snippet[], Error>(queryKeys.fetchSnippets.allByFilters(snippetParams), async () =>
    fetchSnippets(snippetParams)
  );
};
